// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.text-block__list-item[data-v-0bf54fc2]{margin-inline-start:calc(var(--default-grid-baseline)*4)}`, "",{"version":3,"sources":["webpack://./src/components/textBlocks/List.vue"],"names":[],"mappings":"AACA,wCACC,wDAAA","sourcesContent":["\n.text-block__list-item {\n\tmargin-inline-start: calc(var(--default-grid-baseline) * 4);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
